<template>
	<div class="waper">
		<div class="waper-bg">
			<p class="title">农机购置与应用补贴物联网管理系统</p>
			<div class="box">
				<div class="boxTitle" style="color: #0C3897;font-size: 1vw;font-family: MicrosoftYaHei">系统登录</div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="padding-bottom: 1vh;padding-top:1vh;" v-on:keyup.enter.native="submitForm('ruleForm')">
					<el-form-item label="" prop="Egname" style="margin-bottom: 1vh !important;">
						<!--<img src="../../static/img/User.png" style="width:22px;height: 22px;position: relative;top:5px;padding-right: 5px;">-->
						<i class="el-icon-user" style="color: #409EFF;font-size: 1.3vw;position: relative;top:5px"></i>
						<input placeholder="请输入账号或者手机号" v-model="ruleForm.Egname" @change="handleChangeUserName" class="borderNone" />
					</el-form-item>
					<el-form-item label="" prop="Egpassword" style="margin-bottom: 1vh !important;">
						<!--<img src="../../static/img/Locked.png" style="width:22px;height: 22px;position: relative;top:5px;padding-right: 5px;">-->
						<i class="el-icon-lock" style="color: #409EFF;font-size: 1.3vw;position: relative;top:5px"></i>
						<input placeholder="请输入密码" type="password" v-model="ruleForm.Egpassword" @change="handleChangePassword" class="borderNone" />
					</el-form-item>
				</el-form>
				<!--<dragVerifys ref="Verify"></dragVerifys>-->
				<!-- <div id="loding">
					<el-button style="width:90%;position: relative;left: 5%;padding: 1vh 2vw;font-size: 1vw" type="primary" round @click="submitForm('ruleForm')" >登录</el-button>
				</div> -->
				<slider-verify ref="sliderVerify" :disabled="disabled" :host="host" :appid="appid" :appsecret="appsecret" @success="onSuccess" @fail="onFail" @again="onAgain" :canvasWidth="canvasWidth" :canvasHeight="canvasHeight" :blockWidth="65" :blockHeight="55" />
			</div>
		</div>
		<div class="footer">
			<div class="copyright">
				<span>技术服务：大田互通物联技术有限公司</span>
			</div>
			<div class="copyrights">
				<span @click="hrefClick">京ICP备14027879号-14　</span>
				<span @click="hrefChange">京公网安备11010802020671号</span>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	import dragVerifys from './DragVerify.vue'
	import http from '../Serves/net-http.js'
	import Api from '../Serves/net-api.js'
	import { JSEncrypt } from 'jsencrypt'
	import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
	import Vue from 'vue'
	import 'font-awesome/css/font-awesome.min.css'
	import dragVerify from 'vue-drag-verify'
	export default {
		name: 'Login',
		components: {
			dragVerifys
		},
		computed: {
			...mapState({
				details: state => state.details,
				Code: state => state.Code,
				Index: state => state.Index
			})
		},
		data() {
			var check = (rule, value, callback) => {
				while(value.lastIndexOf(" ") >= 0) {
					value = value.replace(" ", "");
				}
				if(value.length == 0) {
					callback("输入不能为空字符")
				} else {
					callback()
				}
			}
			return {
				names: '',
				password: '',
				// handlerIcon:'fa fa-angle-double-right',
				// successIcon:'fa fa-check',
				// background:'#cccccc',
				// progressBarBg:'#FFFF99',
				// completedBg:'#66cc66',
				// handlerBg:'#fff',
				// text:'请将滑块拖至最右端',
				// successText:'解锁成功',
				// width:300,
				// height:40,
				// textSize:'16px',
				// isCircle:'true',
				ruleForm: {
					Egname: '',
					Egpassword: '',
				},
				/*handlerIcon: "fa fa-angle-double-right",
				successIcon: "fa el-icon-circle-check",
				background: "#e8e8e8",
				progressBarBg: "#3094F2",
				completedBg: "#3094F2",
				handlerBg: "#fff",
				text: "<span class='aa'>请将滑块拖动到右侧</span>",
				successText: "<div style='color: #fff'>验证成功</div>",
				// width: 328,
				  width:0,
				height: 42,
				textSize: "14px",
				isCircle:'true',*/
				rules: {
					Egname: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							validator: check,
							trigger: 'blur'
						}
						/*{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
					],
					Egpassword: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							validator: check,
							trigger: 'blur'
						}
					]
				},
				host: 'https://bs.datian360.com',
				appid: 'finance',
				appsecret: 'finance',
				canvasWidth: 0,
				canvasHeight: 0,
				disabled: true,
				intervallIndex: 0,
				publicKey: '',
      			uuid: '',
			}
		},
		watch: {
			canvasWidth: {
				immediate: true,
				handler: function(newVal) {
					if(this.$refs.sliderVerify) {
						this.$refs.sliderVerify.init();
					}
				},
				deep: true
			},
			intervallIndex(newVal, oldVal) {
				//监听浏览器自动填充账号密码
				if(this.inputBgVal.indexOf(232) > 0 || this.inputBgVal.indexOf(189) > 0) {
					this.disabled = false
				} else {
					this.disabled = true
				}
				clearInterval(this.timer)

			},
		},
		methods: {
			...mapMutations(['saveTabkeInfo']),
			handleChangeUserName(e) {
				if(e.target.value && this.ruleForm.Egpassword) {
					this.disabled = false
				} else {
					this.disabled = true
				}
			},
			handleChangePassword(e) {
				if(e.target.value && this.ruleForm.Egname) {
					this.disabled = false
				} else {
					this.disabled = true
				}
			},
			/* 滑动验证成功*/
			onSuccess(captcha) {
				//				captcha的值为{nonceStr: "eddcda4a95ce4f879cdfbf9a2733f4a4",value: 90}，需要合并登录账号密码等参数，传给登录接口
				//在此处调用登录接口
				//				this.$refs.sliderVerify.verifySuccessEvent();
				Object.assign(this.ruleForm, captcha);
				this.submitForm('ruleForm')
			},
			/* 滑动验证失败*/
			onFail() {
				this.$refs.sliderVerify.verifyFailEvent();
			},
			/* 滑动验证异常*/
			onAgain() {
				this.$message({
					showClose: true,
					message: '滑动操作异常，请重试',
					type: 'warning'
				})
				this.$refs.sliderVerify.refresh();
			},
			getCaption(url, parameter) {
				var index = url.lastIndexOf(parameter);
				url = url.substring(index + 1, url.length);
				return url;
			},
			// 获取公钥
			getPublicKey () {
				axios.post(http.getPkAndUuid, { }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
					this.publicKey = res.data.publicKey
					this.uuid = res.data.uuid
				}).catch(function (errs) {
					console.log('Exception in doPost() ：', errs)
				})
			},
			submitForm(formName) {
				var lodaing = document.getElementById('loding')
				this.$refs[formName].validate((valid) => {
					if(valid) {
						var provCode = ''
						let centerLngLat = []
						if(window.location.host === 'shanghai.dtwl360.com') {
							provCode = 31
							centerLngLat = [121.48848100292, 31.2097925548583]
						} else if(window.location.host === 'beijing.dtwl360.com') {
							provCode = 11
							centerLngLat = [116.407387, 39.904179]
						} else if(window.location.host === 'chongqing.dtwl360.com') {
							provCode = 50
							centerLngLat = [106.550464, 29.563761]
						} else if(window.location.host === 'fujian.dtwl360.com') {
							provCode = 35
							centerLngLat = [119.306239, 26.075302]
						} else if(window.location.host === 'henan.dtwl360.com') {
							provCode = 41
							centerLngLat = [113.665412, 34.757975]
						} else if(window.location.host === 'taiwan.dtwl360.com') {
							provCode = 99
							centerLngLat = [120.883939, 23.266025]
						} else if(window.location.host === 'shandong.dtwl360.com') {
							provCode = 37
							centerLngLat = [117.019973, 36.671199]
						} else if(window.location.host === 'xjbt.dtwl360.com') {
							provCode = 71
							centerLngLat = [87.509259, 43.83667]
						} else if(window.location.host === 'ningxia.dtwl360.com') {
							provCode = 64
							centerLngLat = [106.258889, 38.472273]
						} else if(window.location.host === 'qingdao.dtwl360.com') {
							provCode = 370200000000
							centerLngLat = [120.382665, 36.066938]
						} else if(window.location.host === 'jiangxi.dtwl360.com') {
							provCode = 36
							centerLngLat = [115.892151, 28.676493]
						} else if(window.location.host === 'hunan.dtwl360.com') {
							provCode = 43
							centerLngLat = [112.982279, 28.19409]
						} else if(window.location.host === 'sichuan.dtwl360.com') {
							provCode = 51
							centerLngLat = [104.065735, 30.659462]
						} else if(window.location.host === 'hebei.dtwl360.com') {
							provCode = 13
							centerLngLat = [114.502461, 38.045474]
						} else if(window.location.host === 'gansu.dtwl360.com') {
							provCode = 62
							centerLngLat = [103.823557, 36.058039]
						} else if(window.location.host === 'national.dtwl360.com') {
							provCode = ''
							centerLngLat = [108.928439, 34.539281]
						} else if(window.location.host === 'neimeng.dtwl360.com') {
							provCode = 15
							centerLngLat = [112.3467, 41.4899]
						} else if(window.location.host === 'xiamen.dtwl360.com') {
							provCode = 350200000000
							centerLngLat = [118.1689, 24.6478]
						} else if(window.location.host === 'ningbo.dtwl360.com') {
							provCode = 330200000000
							centerLngLat = [121.51089, 29.862348]
						} else if(window.location.host === 'jiangsu.dtwl360.com' || window.location.host === 'huaxia.dtwl360.com') {
							provCode = 32
							centerLngLat = [120.2234, 33.5577]
						} else if(window.location.host === 'xinjiang.dtwl360.com') {
							provCode = 65
							centerLngLat = [87.9236, 43.5883]
						} else if(window.location.host === 'guangdong.dtwl360.com') {
							provCode = 44
							centerLngLat = [113.280637, 23.125178]
						} else if(window.location.host === 'zhejiang.dtwl360.com') {
							provCode = 33
							centerLngLat = [119.2566, 29.2456]
						} else if(window.location.host === 'tianjin.dtwl360.com') {
							provCode = 12
							centerLngLat = [117.190182, 39.125596]
						} else if(window.location.host === 'guangxi.dtwl360.com') {
							provCode = 45
							centerLngLat = [108.320004, 22.82402]
						} else if(window.location.host === 'hubei.dtwl360.com') {
							provCode = 42
							centerLngLat = [114.3896, 30.6628]
						} else if(window.location.host === 'anhui.dtwl360.com') {
							provCode = 34
							centerLngLat = [117.283042, 31.86119]
						} else if(window.location.host === 'qinghai.dtwl360.com') {
							provCode = 63
							centerLngLat = [101.778916, 36.623178]
						} else if(window.location.host === 'bdh.dtwl360.com') {
							provCode = 91
							centerLngLat = [126.642464, 45.756967]
						} else if(window.location.host === 'sx.dtwl360.com') {
							provCode = 61
							centerLngLat = [108.948024,34.263161]
						} else if(window.location.host === 'liaoning.dtwl360.com') {
							provCode = 21
							centerLngLat = [123.429096,41.796767]
						} else if(window.location.host === 'yunnan.dtwl360.com') {
							provCode = 53
							centerLngLat = [102.712251,25.040609]
						} else {
							provCode = 35
							centerLngLat = [119.306239, 26.075302]
						}
						if(this.ruleForm.Egname == 'yzq') {
							centerLngLat = [115.806942, 32.883468]
						}
						var pass = this.ruleForm.Egpassword // 密码
						var newPass = '' // 加密后数据
						// 新建JSEncrypt对象
						const encryptor = new JSEncrypt()
						// 设置公钥
						encryptor.setPublicKey(this.publicKey)
						// 加密数据
						newPass = encryptor.encrypt(pass)
						sessionStorage.setItem('centerLngLat', centerLngLat.join(','))
						var url = http.test + '/login/signIn'
						var parmse = {
							username: this.ruleForm.Egname,
							password: newPass,
							uuid: this.uuid,
							// password: this.ruleForm.Egpassword,
							provCode: provCode,
							type: window.location.host === 'jiangsu.dtwl360.com' || window.location.host === 'huaxia.dtwl360.com' ? 'view' : undefined,
							nonceStr: this.ruleForm.nonceStr,
							slidePixel: this.ruleForm.value
						}
						Api.doLogin(url, parmse, false, lodaing, (res) => {
							localStorage.setItem('userName', this.ruleForm.Egname)
							localStorage.setItem('token', res.result.token)
							localStorage.setItem('userLevel', res.result.userLevel)
							
							setTimeout(() => {
								if (window.location.host === 'tianjin.dtwl360.com') {
									this.$router.push({
										path: '/positioning-monitor'
									});
								} else {
									if (this.$store.state.info.loginName == "bjview") {
										this.$router.push({
											path: '/positioning-monitor'
										});
									} else {
										this.$router.push({
											path: '/'
										});
									}
									
								}
							}, 100)
							this.$store.commit('Index', 1);
						}, (err) => {
							// console.log("err")
							this.$refs.sliderVerify.refresh();
						})
						this.$refs.sliderVerify.refresh();
					} else {
						this.$refs.sliderVerify.refresh();
						return false
					}
				})
			},

			
			// ...mapActions(['getAccountInfo']),
			// getAccountInfo () {
			//   Api.doPost(http.test+'/account/getAccountInfo', null, false, (res) => {
			//     const userInfo = res.result.userInfo
			//     this.$store.commit('Code', userInfo.areaCode)
			//     this.$store.commit('areaName', userInfo.areaName)
			//     this.$store.commit('SET_INFO', userInfo)
			//     if (userInfo.roleName) {
			//       this.$store.commit('SET_ROLES', [ userInfo.roleName ])
			//     }
			//     resolve(res)
			//   })
			// },
			hrefClick() {
				window.open('https://beian.miit.gov.cn', '_blank');
			},
			hrefChange() {
				window.open('http://www.beian.gov.cn', '_blank');
			}
		},
		mounted() {
			//监听浏览器自动填充账号密码
			let this_ = this;
			this.timer = setInterval(function() {
				this_.intervallIndex++
					this_.inputBgVal = getComputedStyle(document.querySelectorAll("input")[0], ":-internal-autofill-selected").background;
			}, 1000);
			this.$nextTick(() => {
				if(this.ruleForm.Egname && this.ruleForm.Egpassword) {
					this.disabled = false
				} else {
					this.disabled = true
				}
				var _this = this
				_this.canvasWidth = document.getElementsByClassName('el-form-item__content')[0].offsetWidth
				_this.canvasHeight = document.getElementsByClassName('box')[0].offsetHeight - document.getElementsByClassName('el-form')[0].offsetHeight - document.getElementsByClassName('boxTitle')[0].offsetHeight - Math.round(document.body.offsetHeight / 8.8)
			})
			this.getPublicKey()
		}
	}
</script>
<style scoped>
	i::selection,
	div::selection {
		background: transparent;
	}
	
	.box {
		width: 370px;
		height: 40%;
		min-height: 320px;
		border: 1px solid #E8E7E7;
		border-radius: 10px;
		position: absolute;
		top: 33%;
		right: 8%;
		background-color: #ffffff;
		padding: 25px 38px;
	}
	
	input {
		padding: 0 10px;
		box-sizing: border-box;
	}
	
	.waper {
		width: 100%;
		height: 100%;
	}
	
	.waper-bg {
		background: url("../assets/comm/login_bg@2x.png")no-repeat;
		/*position:fixed;*/
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		min-width: 1000px;
		z-index: -10;
		zoom: 1;
		background-color: #fff;
		background-repeat: no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
	}
	
	.borderNone {
		border: none;
		height: 40px;
		width: 90%;
		margin: 6px 0 0px 0;
		border-bottom: 1px solid #E8E7E7;
	}
	
	input,
	textarea,
	select,
	a:focus {
		outline: none;
	}
	
	.title {
		color: #2289F2;
		font-size: 60px;
		padding-top: 60px;
		font-weight: 800;
		text-align: center;
		/*background-image:-webkit-linear-gradient(bottom,#38D7FF,#38D7FF,#2289F2);*/
	}
	
	input::-webkit-input-placeholder {
		color: #E8E7E7;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #E8E7E7;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #E8E7E7;
	}
	
	input:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: #E8E7E7;
	}
	
	.footer {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
	}
	
	.copyright {
		color: #2289F2;
		font-size: 0.8vw;
		padding-bottom: 10px;
		text-align: center;
	}
	
	.copyrights {
		color: #2289F2;
		font-size: 0.7vw;
		padding-bottom: 10px;
		text-align: center;
	}
	
	.copyrights span {
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue